import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { useState } from 'react';
import { useParams } from 'react-router-dom';

import { ListItems } from '../components/item-list';
import { OrderInfo } from '../components/order-info';
import { TotalList } from '../components/totals';
import { useQueryCustom } from '../hooks/query-receipt';
import {RECEIPT_ONE_TICKETING} from '../query/receipt-one.query';

export const ReceiptTicketing = () => {
  const { id } = useParams(); // from React Router v6

  const [refVariables] = useState({
    reference_id: id,
  });

  const { data } = useQueryCustom({
    graphqlQuery: RECEIPT_ONE_TICKETING,
    variables: refVariables,
  });

  const order = data?.orders_ticketing?.[0] || null;

  return order ? (
      <Box maxWidth="40em" margin="2.5em auto">
        <Container>
          <OrderInfo data={order} />
          <ListItems order={order} />
          <TotalList data={order} />
        </Container>
      </Box>
  ) : null;
};
